import { FC, useState } from 'react'
import { Button, TextArea } from '@pepper/ui'
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { useHistory } from 'react-router-dom'

import { trimCommaSeparatedList } from '../../../utils'

import s from './Topics.module.css'

type Props = {
  onChange: () => void
}

export const Topics: FC<Props> = ({ onChange }) => {
  const [topics, setKeywords] = useState('')
  const history = useHistory()

  const [queryParams, setQueryParams] = useQueryParams({
    topic: withDefault(StringParam, undefined),
    sug_topic: withDefault(StringParam, undefined),
    page: withDefault(NumberParam, 1),
    content_ideas: withDefault(BooleanParam, false),
  })

  const isSuggestionsFilter =
    history.location.pathname === '/content-ideas' || queryParams.content_ideas

  const handleSubmit = () => {
    const topicsContainList = trimCommaSeparatedList(topics)
    if (isSuggestionsFilter) {
      setQueryParams({ sug_topic: topicsContainList, page: 1 })
    } else {
      setQueryParams({ topic: topicsContainList, page: 1 })
    }
    onChange()
  }

  return (
    <div className={s.menu}>
      <div className={s.title}>Enter topics separated by commas</div>
      <TextArea
        name="topics-containing"
        className={s.textField}
        placeholder="Example: automation, artificial intelligence, "
        rows={4}
        onChange={event => setKeywords(event.target.value)}
      />
      <div className={s.submit}>
        <Button
          size="large"
          block={false}
          type="primary"
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}
